var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowUpRight = function SvgArrowUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.646 13.646a.5.5 0 1 0 .708.707L13.5 7.207V14a.5.5 0 0 0 1 0V6a.498.498 0 0 0-.522-.5H6a.5.5 0 0 0 0 1h6.792l-7.146 7.146Z",
    fill: "currentColor"
  })));
};

export { SvgArrowUpRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjY0NjQzIDEzLjY0NjVDNS40NTExOCAxMy44NDE3IDUuNDUxMTkgMTQuMTU4MyA1LjY0NjQ3IDE0LjM1MzZDNS44NDE3NCAxNC41NDg4IDYuMTU4MzIgMTQuNTQ4OCA2LjM1MzU4IDE0LjM1MzVMMTMuNSA3LjIwNjI1TDEzLjUgMTRDMTMuNSAxNC4yNzYxIDEzLjcyMzkgMTQuNSAxNCAxNC41QzE0LjI3NjEgMTQuNSAxNC41IDE0LjI3NjEgMTQuNSAxNEwxNC41IDUuOTk5OThDMTQuNSA1Ljg2MDcxIDE0LjQ0MzEgNS43MzQ3MyAxNC4zNTEyIDUuNjQ0MDdDMTQuMjQ4MiA1LjU0MjE5IDE0LjExMiA1LjQ5NDE2IDEzLjk3NzcgNS40OTk5OEw2IDUuNDk5OThDNS43MjM4NiA1LjQ5OTk4IDUuNSA1LjcyMzg0IDUuNSA1Ljk5OTk4QzUuNSA2LjI3NjEzIDUuNzIzODYgNi40OTk5OCA2IDYuNDk5OThMMTIuNzkyIDYuNDk5OThMNS42NDY0MyAxMy42NDY1WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";